import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SystemsInventoryRequestService } from '../../service/systems-inventory-request/systems-inventory-request.service';
import { SystemsInventoryRequest } from '../../class/systems-inventory-request';
import { Message, ConfirmationService, LazyLoadEvent } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-systems-inventory-requests',
  templateUrl: './systems-inventory-requests.component.html',
  styleUrls: ['./systems-inventory-requests.component.scss']
})
export class SystemsInventoryRequestsComponent implements OnInit, OnDestroy {
  public promiseForm: Promise<any>;
  public msgs: Message[] = [];
  public systemsInventoryRequest: SystemsInventoryRequest[];
  public selectSystemsInventoryRequest: SystemsInventoryRequest;
  public systemsInventoryRequestID: Number = 0;
  public modNew = false;
  public modView = false;
  public openSystemsInventoryRequest = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public systemsInventoryRequestPosition: string;
  public filters: { key: string, value: string }[];

  public first = 0;

  public showFilter: boolean;

  public form1: FormGroup;

  public form2: FormGroup;

  public apiUrl = config.API_ROOT;

  public modExportDialog: boolean;

  public statusOptions: SelectItem[];
  public type_problemOptions: SelectItem[];
  public priorityOptions: SelectItem[];

  public pagePath: string;
  public subPagePath: string;

  public myEmployeeId: string;
  public verification: boolean;
  public params_id_dev_req: number;
  public showNewSystemsInventoryRequest: boolean;
  public showExportSystemsInventoryRequest: boolean;
  public reloadInterval: any;
  public loading: boolean;

  public equipmentTypeOptions: any[];
  public equipmentBrandOptions: any[];

  public ReportTypeExportExcelOptions: any[];
  public equipmentStatusOptions: any[];
  public es: any;

  constructor(
    public SystemsInventoryRequestService: SystemsInventoryRequestService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    private route: ActivatedRoute,
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder
  ) {
    this.loading = false;
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';


    this.es = calendarES();

    this.equipmentStatusOptions = [
      { id: 1, label: 'Nuevo', value: 'Nuevo' },
      { id: 2, label: 'Usado sin defectos', value: 'Usado sin defectos' },
      { id: 3, label: 'Usado con defectos', value: 'Usado con defectos' },
      { id: 4, label: 'Dañado', value: 'Dañado' },
      { id: 5, label: 'Vendido', value: 'Vendido' },
      { id: 6, label: 'Donado', value: 'Donado' },
      { id: 7, label: 'Robado', value: 'Robado' }
    ];
    this.equipmentTypeOptions = [
      { label: 'Todos', value: 'all' },
      { label: 'Computador de escritorio', value: 'Computador de escritorio' },
      { label: 'Computador portátil', value: 'Computador portátil' },
      { label: 'Celular', value: 'Celular' },
      { label: 'Impresora', value: 'Impresora' },
      { label: 'Otro', value: 'Otro' },
    ];

    this.equipmentBrandOptions = [
      { label: 'Todos', value: 'all' },
      { label: 'Asus', value: 'Asus' },
      { label: 'Hewlett-Packard (HP)', value: 'Hewlett-Packard (HP)' },
      { label: 'Lenovo', value: 'Lenovo' },
      { label: 'Epson', value: 'Epson' },
      { label: 'LG', value: 'LG' },
      { label: 'Genius', value: 'Genius' },
      { label: 'Otro', value: 'Otro' },
    ];

    this.statusOptions = [
      { label: 'Todos', value: 'all' },
      { label: 'Por hacer', value: 'Por hacer' },
      { label: 'Programado', value: 'Programado' },
      { label: 'En ejecución', value: 'En ejecución' },
      { label: 'Cerrado', value: 'Cerrado' },
    ];

    this.modExportDialog = false;

    this.loading = false;

    this.ReportTypeExportExcelOptions = [
      { label: 'Reporte de inventario - Seguimiento', value: 'Reporte de inventario - Seguimiento' },
      { label: 'Reporte de inventario - Último asignado', value: 'Reporte de inventario - Último asignado' },
    ];
  }

  ngOnInit() {
    this.showFilter = true;

    this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;

    this.filters = [];

    this.reloadInterval = setInterval(() => {
      if (this.verification) {
        this.getSystemsInventoryRequest();
      }
    }, 50000);

    this.createForm1(null);
    this.createForm2(null);
  }

  createForm1(data: any = null) {
    data = data || {
      equipment_type_filter: 'all',
      equipment_brand_filter: 'all',
      assigned_to_by_id_filter: null,
      venue_id_filter: '',
      equipment_status_filter: '',
    };
    this.form1 = this.fb.group({
      equipment_type_filter: new FormControl(data.equipment_type_filter),
      equipment_brand_filter: new FormControl(data.equipment_brand_filter),
      assigned_to_by_id_filter: new FormControl(data.assigned_to_by_id_filter),
      venue_id_filter: new FormControl(data.venue_id_filter),
      equipment_status_filter: new FormControl(data.equipment_status_filter),
    });
  }

  createForm2(data: any = null) {
    data = data || {
      report_type: '',
      date_start: '',
      date_end: '',
      equipment_type: 'all',
    };
    this.form2 = this.fb.group({
      report_type: new FormControl(data.report_type, Validators.compose([Validators.required])),
      date_start: new FormControl(data.date_start, Validators.compose([Validators.required])),
      date_end: new FormControl(data.date_end, Validators.compose([Validators.required])),
      equipment_type: new FormControl(data.equipment_type, Validators.compose([Validators.required])),
    });
  }


  ngOnDestroy() {
    // Will clear when component is destroyed e.g. route is navigated away from.
    clearInterval(this.reloadInterval);
  }

  public loadSystemsInventoryRequestLazy(event: LazyLoadEvent) {
    this.query = "";
    this.page = (event.first / this.per_page) + 1;
    if (event.sortOrder === -1) {
      this.sort = '-' + event.sortField;
    }
    else {
      if (event.sortField) {
        this.sort = event.sortField;
      } else {
        this.sort = '-id';
      }
    }

    if (event.globalFilter) {
      this.filters.push({ 'key': 'fixed_asset', 'value': event.globalFilter });
    }
    this.getSystemsInventoryRequest();
  }
  getSystemsInventoryRequest() {
    this.loading = true;
    this.SystemsInventoryRequestService.getSystemsInventoryRequest(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
      response => {
        this.loading = false;
        this.systemsInventoryRequest = response.json().data;
        if (response.json().meta.total > response.json().meta.total_filtered) {
          this.totalRecords = response.json().meta.total_filtered;
        } else {
          this.totalRecords = response.json().meta.total;
        }
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'No se puede realizar la solicitud' });
      }
    );
  }

  public newSystemsInventoryRequest() {
    this.modNew = !this.modNew;
    this.selectSystemsInventoryRequest = null;
  }

  public savedSystemsInventoryRequest(res) {
    this.msgs = [];
    this.msgs.push(res);
    this.selectSystemsInventoryRequest = null;
    this.modNew = false;
  }

  public cancelSystemsInventoryRequest(res) {
    this.selectSystemsInventoryRequest = null;
    this.modNew = false;
    this.modView = false;
  }

  public edit(systemsInventoryRequest: SystemsInventoryRequest) {
    this.modNew = true;
    this.selectSystemsInventoryRequest = systemsInventoryRequest;
  }

  public view(systemsInventoryRequest: SystemsInventoryRequest) {
    this.openSystemsInventoryRequest = true;
    this.selectSystemsInventoryRequest = systemsInventoryRequest;
    this.systemsInventoryRequestID = systemsInventoryRequest.id;
    this.modView = true;
  }

  public deleteDialog(systemsInventoryRequest: SystemsInventoryRequest) {
    let message;
    this.translate.get('Do you want to delete?').subscribe((res: string) => {
      message = res;
    });

    let header;
    this.translate.get('Delete Confirmation').subscribe((res: string) => {
      header = res;
    });

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'fa fa-trash',
      accept: () => {
        this.delete(systemsInventoryRequest);
      }
    });
  }

  public delete(systemsInventoryRequest: SystemsInventoryRequest) {
    this.SystemsInventoryRequestService.deleteSystemsInventoryRequest(systemsInventoryRequest.id).toPromise().then(
      response => {
        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Solicitud eliminada' });
        this.getSystemsInventoryRequest();
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Error al eliminar' });
      }
    );
  }

  public activeSystemsInventoryRequest(systemsInventoryRequest: SystemsInventoryRequest) {
    this.putSystemsInventoryRequest(systemsInventoryRequest);
  }

  public putSystemsInventoryRequest(values: SystemsInventoryRequest) {
    const param = {
      'activated': values.activated
    };
    if (values) {
      const promise = this.SystemsInventoryRequestService.updateSystemsInventoryRequest(values.id, param);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: res });
          });
        },
        error => {
          this.msgs.push({ severity: 'error', summary: 'No se puede actualizar la solicitud' });
        }
      );
    }
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public hasRole(rol) {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    if (role == rol) {
      r = true;
    }
    return (r);
  }

  public filter(values?) {
    this.page = 1;
    this.first = 0;
    this.filters = [];

    if (values.equipment_brand_filter !== 'all' && values.equipment_brand_filter !== '')
      this.filters.push({ 'key': 'equipment_brand_filter-lk', 'value': values.equipment_brand_filter });

    if (values.equipment_type_filter !== 'all' && values.equipment_type_filter !== '')
      this.filters.push({ 'key': 'equipment_type_filter-lk', 'value': values.equipment_type_filter });

    if (values.assigned_to_by_id_filter !== null && values.assigned_to_by_id_filter !== '' && values.assigned_to_by_id_filter !== undefined)
      this.filters.push({ 'key': 'assigned_to_by_id_filter-lk', 'value': values.assigned_to_by_id_filter.id });

    if (values.venue_id_filter !== null && values.venue_id_filter !== '' && values.venue_id_filter !== undefined)
      this.filters.push({ 'key': 'venue_id-lk', 'value': values.venue_id_filter });

    if (values.equipment_status_filter !== null && values.equipment_status_filter !== '' && values.equipment_status_filter !== undefined)
      this.filters.push({ 'key': 'equipment_status-lk', 'value': values.equipment_status_filter });
    this.getSystemsInventoryRequest();
  }

  getSystemsInventoryRequestById(query?: string, filters?: any[]) {
    this.loading = true;
    this.SystemsInventoryRequestService.getSystemsInventoryRequest(this.page, this.per_page, this.sort, query, filters).toPromise().then(
      response => {
        this.loading = false;
        this.edit(response.json().data[0]);
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'No se puede realizar esta acción' });
      }
    );
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }

  public exportReportExcel(values) {
    let d = new Date(values.date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const date_start = formatDate(d);

    d = new Date(values.date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const date_end = formatDate(d);

    let url = this.apiUrl + '/systems-inventory/excel?' +
      'token=' + localStorage.getItem('token') +
      '&_page=1&_limit=100000&_sort=id&';

    if (date_start)
      url = url + 'created_at-min=' + date_start + '&';

    if (date_end)
      url = url + 'created_at-max=' + date_end + '&';

    if (values.venue_id)
      url = url + 'venue_id-in=' + values.venue_id + '&';

    if (values.equipment_type !== 'all' && values.equipment_type !== '')
      url = url + 'equipment_type-in=' + values.equipment_type + '&';

    window.open(url + '&type=' + values.report_type.value, '_blank');
  }

  public getLifeStateUtil(purchase_date: Date): string {
    const resul = this.SystemsInventoryRequestService.calculateUtilLife(purchase_date);
    return resul.state;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/systems-inventory-requests/systems-inventory-requests.component.ts